import styled from "styled-components";
import { currentColors } from "../../colors";
import Streetview, { ASPECT_RATIO } from "../Streetview";

export const ButtonRow = styled.div`
    display: flex;
    justify-content: center;
    gap: 3px;
    margin-bottom: 2rem;

    button {
        margin-bottom: 0;
    }
`;

interface IErrorProps {
    $error: boolean;
}

export const Label = styled.label<IErrorProps>`
    color: ${(props) => (props.$error ? currentColors.error : currentColors.text)};
    cursor: pointer;
    display: block;
    font-size: .875rem;
    margin-bottom: 0;
`;

export const Input = styled.input<IErrorProps>`
    &[type="text"], &[type="password"] {
        border-radius: ${({ $error }) => ($error ? "0.65rem 0.65rem 0 0" : "0.65rem")};
        background-color: white;
        border: 1px solid ${currentColors.text};
        border-bottom-color: ${({ $error }) => ($error ? currentColors.error : currentColors.text)};
        color: ${currentColors.text};
        display: block;
        font-size: .875rem;
        margin: 0;
        padding: .5rem;
    }
`;

export const Select = styled.select<IErrorProps>`
    border-radius: ${({ $error }) => ($error ? "0.65rem 0.65rem 0 0" : "0.65rem")};
    background-color: white;
    border: 1px solid ${currentColors.text};
    border-bottom-color: ${({ $error }) => ($error ? currentColors.error : currentColors.text)};
    color: ${currentColors.text};
    display: block;
    font-size: .875rem;
    margin: 0;
    padding: .5rem;
`;

export const ErrorBox = styled.small`
    display: block;
    font-size: .75rem;
    font-style: italic;
    padding: .375rem .5625rem .5625rem;
    background: ${currentColors.error};
    color: white;
    border-radius: 0 0 0.65rem 0.65rem;
`;

export const TermsContainer = styled.div`
    overflow-y: scroll;
    margin-bottom: 1rem;
    border: 1px solid ${currentColors.grey3};
    padding: 5px;
    border-radius: 5px;
    height: 600px;
    max-height: 100vh;

    p {
        font-size: calc(0.85 * 1rem);
    }
    h2 {
        font-size: calc(0.85 * 2.3125rem);
    }
    h3 {
        font-size: calc(0.85 * 1.6875rem);
    }
    h4 {
        font-size: calc(0.85 * 1.4375rem);
    }
    h5 {
        font-size: calc(0.85 * 1.125rem);
    }
`;

export const AspectBox = styled.div`
    position: relative;
    margin-bottom: 1rem;
    overflow: hidden;
    background: white;
    height: 0;
    padding-top: ${ASPECT_RATIO}%;
    width: 100%;
`;

export const Background = styled(Streetview)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const AvatarList = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    max-width: 1000px;
    margin: 0 auto;

    img {
        cursor: pointer;
    }
`;

export const SelectedAvatar = styled.img`
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%,-10%);
    object-position: center;
    object-fit: contain;
    object-position: center;
    width: min(90px, 16vw);
`;

export const FileButton = styled.label`
    border: 0;
    text-align: center;
    display: inline-block;
    line-height: normal;
    padding: 1rem 2rem 1.0625rem 2rem;
    font-size: 1rem;
    background-color: ${currentColors.button};
    color: white;
    transition: background-color 300ms ease-out;
    &:hover, &:focus, &:active, &:visited {
        background-color: ${currentColors.button};
        color: white;
    }
`;

export const FileInput = styled.input`
    position: absolute;
    display: none;
    visibility: invisible;
`;

export const FormGrid = styled.div`
    display: grid;
    gap: 1rem;
    margin-bottom: 2rem;
`;

export const PictureGrid = styled.div`
    display: grid;
    gap: 1rem;
    margin-bottom: 2rem;
    justify-content: center;
    justify-items: center;
`;

export const PictureImg = styled.img`
    width: 130px;
    height: 130px;
    object-fit: contain;
`;

export const ReviewGrid = styled.div`
    display: grid;
    gap: 1rem;
    margin-bottom: 2rem;

    @media screen and (min-width: 800px) {
        grid-template-columns: 1fr 1fr;
    }
`;

export const ReviewBox = styled.div`
    padding: 0.5rem;
    border-radius: 0.65rem;
    border: 1px solid ${currentColors.text};
    position: relative;
    font-size: 1.1rem;

    input {
        margin-bottom: 0;
    }
`;

export const ReviewAvatar = styled.img`
    width: 90px;
    height: 200px;
`;

export const Nav = styled.nav`
    display: flex;
    gap: 0 1rem;
    margin-bottom: 1rem;
    justify-content: space-around;
    position: relative;
    overflow: hidden;
    flex-wrap: wrap;
    background-image: url("data:image/png;base64,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");
    background-repeat: repeat;
`;

interface INavItem {
    $disabled: boolean;
}

export const NavItem = styled.div<INavItem>`
    background-color: white;
    color: ${({ $disabled }) => ($disabled ? currentColors.grey3 : currentColors.link)};
    padding: 0 0.5rem;
    cursor: ${({ $disabled }) => ($disabled ? "auto" : "pointer")};
`;
